import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/app-store-ios': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM127 384.5l19.3-33.3c-10.3-12.5-23.5-16.3-39.6-11.4l-14.3 24.7c-5.5 9.5-2.3 21.8 7.3 27.3 9.5 5.5 21.8 2.3 27.3-7.3zM265.9 330.6c8.8-16.3-2.5-40-22.7-40h-62.1l85.8-148.6c5.5-9.5 2.3-21.8-7.3-27.3-9.5-5.5-21.8-2.3-27.3 7.3l-8.9 15.4-8.9-15.4c-5.5-9.5-17.7-12.8-27.3-7.3-9.5 5.5-12.8 17.7-7.3 27.3l20.5 35.4-65.4 113.2h-51c-11 0-20 9-20 20s9 20 20 20h181.9zM364 330.6c11 0 20-8.9 20-20 0-11-9-20-20-20h-52c-26.2-45.3-45.8-79.3-58.9-102-11.9 9.8-23.8 38.8-7.1 67.8 16.5 28.4 41.1 71.2 74 128.1 5.5 9.5 17.7 12.8 27.3 7.3 9.5-5.5 12.8-17.7 7.3-27.3l-19.6-33.9h29z'
      }
    ]
  }
})
